import { onMounted, shallowRef } from "vue";
import { useFetch } from "@/core/api/common/composables/useFetch";
import { globals } from "@/core/globals";
import { Logger } from "@/core/utilities";
import type { IState } from "@/core/types/state";

export const ALL_STATES_OPTION_ID = "AllStates";

export function useOptiStates(includeAllStatesOption?: boolean) {
  const states = shallowRef<IState[]>([]);

  const fetchStates = async () => {
    try {
      const { data, error: fetchError } = await useFetch(`${globals.optimizelyUrl}/api/states`).json<IState[]>();

      if (!data?.value || fetchError?.value || !Array.isArray(data?.value)) {
        throw new Error("Failed to fetch valid states.");
      }

      states.value = data.value;
      if (includeAllStatesOption) {
        states.value.unshift({
          id: ALL_STATES_OPTION_ID,
          name: "All States",
        });
      }
    } catch (fetchThrownError) {
      Logger.error("useOptiStates", fetchThrownError);
    }
  };

  onMounted(() => {
    void fetchStates();
  });

  return {
    states,
    fetchStates,
  };
}
